import { Pipe, PipeTransform } from '@angular/core';
import { DataService } from '../../_services';

@Pipe({
  name: 'ellipsis'
})
export class EllipsisPipe implements PipeTransform {

  constructor(private dataService: DataService) {
  }

  transform(value: any, length?: number): any {
    if (value) {
      return this.dataService.ellipsifyMsg(value, length);
    } else {
      return '';
    }
  }

}
